import Vue from 'vue'

export default {
  getMemberAction() {
    return Vue.axios.get('/api/v1/bo/me?include=preferences').then((response) => {
      return response
    })
  },
  getSettingsAction() {
    return Vue.axios.get('/api/v1/bo/setting/all').then((response) => {
      return response.data
    })
  },
  getProcessedPaymentOptionsAction(data) {
    return Vue.axios.get('/api/v1/bo/me/processed-paymentoptions', data).then((response) => {
      return response.data
    })
  },
  getActivePaymentOptionsAction(data) {
    return Vue.axios.get('/api/v1/bo/me/payment-options/active', data).then((response) => {
      return response.data
    })
  },
  getProductsAction() {
    return Vue.axios.get('/api/v1/bo/me/products').then((response) => {
      return response.data
    })
  },
  getNotificationsAction(data) {
    return Vue.axios.get('/api/v1/bo/member/notifications', data).then((response) => {
      return response.data
    })
  },
  readNotificationAction() {
    return Vue.axios.put('/api/v1/bo/member/read-notifications').then((response) => {
      return response.data
    })
  }
}